import { IAlertPermissions } from './IAlertPermissions';
import { IEncouragementPermissions } from './IEncouragementPermissions';
import { IStep } from './IStep';
import { IUpdatePermissions } from './IUpdatePermissions';

export interface INotationWidgetState {
  isLoading: boolean;
  currentStep: IStep;

  //TODO: This should probably be one object
  id?: number;
  institutionId: number;
  createdById?: string;
  createdOn?: string;
  modifiedById?: string;
  titleText: string;
  //@ts-ignore
  descriptionText: string;
  height: number;
  width: number;
  alertPermissions: IAlertPermissions;
  updatePermissions: IUpdatePermissions;
  encouragementPermissions: IEncouragementPermissions;
}

export const notationWidgetInitialState = () => {
  return {
    isLoading: true,
    currentStep: { key: 0, name: 'Welcome Screen', stepNumber: 0 } as IStep,

    id: undefined,
    institutionId: 0,
    createdById: undefined,
    createdOn: undefined,
    modifiedById: undefined,
    titleText: 'Success Network Message',
    descriptionText:
      '<p>Our campus relies on you to ensure that all of our students receive the attention they require to maintain their success. Create an Alert to send a high priority notice to faculty/staff who work with the student or an Update to log a note about the student. Reinforce positive learning strategies by giving students Encouragement. Notifications will be sent out to your colleagues with the contents of your alert or update.</p>',
    height: 450,
    width: 350,
    alertPermissions: {
      showAlerts: 0b1111,
      audience: 0b1110,
      additionalAudience: 0b1110,
      assignTo: 0b1100,
      occurenceDate: 0b1110,
      categories: 0b1000,
      reasons: 0b1000,
    } as IAlertPermissions,
    updatePermissions: {
      showUpdates: 0b1111,
      audience: 0b1110,
      additionalAudience: 0b1110,
      occurenceDate: 0b1110,
      categories: 0b1000,
      reasons: 0b1000,
    } as IUpdatePermissions,
    encouragementPermissions: {
      showEncouragements: 0b0000,
      audience: 0b0000,
    } as IEncouragementPermissions,
  } as INotationWidgetState;
};
